"use client"

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@productlane/lib/src/browser"

export const TooltipProvider = TooltipPrimitive.Provider

export const InternalTooltip = TooltipPrimitive.Root

export const InternalTooltipTrigger = TooltipPrimitive.Trigger

export const InternalTooltipContent = React.memo(
	React.forwardRef<
		React.ElementRef<typeof TooltipPrimitive.Content>,
		React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
	>(({ className, sideOffset = 4, collisionPadding = 8, ...props }, ref) => (
		<TooltipPrimitive.Portal>
			<TooltipPrimitive.Content
				ref={ref}
				sideOffset={sideOffset}
				collisionPadding={collisionPadding}
				className={cn(
					"z-50 max-w-[min(90vw,30rem)] overflow-hidden rounded-md bg-white px-3 py-1.5 text-xs text-gray-700 shadow ring-1 ring-black/10 dark:bg-gray-850 dark:text-gray-400 dark:ring-white/15",
					"!duration-150 ease-out animate-in fade-in zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
					className,
				)}
				{...props}
			/>
		</TooltipPrimitive.Portal>
	)),
)
